import React from 'react';
interface PullQuoteProps {
  quote: string;
  attribution: string;
}
export function PullQuote({
  quote,
  attribution
}: PullQuoteProps) {
  return <figure className="my-12 pl-6 sm:pl-8 border-l-4 border-sage/40 py-2" data-id="element-217">
      <blockquote className="text-2xl sm:text-3xl font-serif italic text-forest leading-snug mb-4" data-id="element-218">
        "{quote}"
      </blockquote>
      <figcaption className="text-sm font-medium text-ink/60 uppercase tracking-wider" data-id="element-219">
        — {attribution}
      </figcaption>
    </figure>;
}